module.exports = __webpack_public_path__ + "921351f146d78d55c8030239527bf2d6.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/FuturaStd-Book.otf
// module id = 863
// module chunks = 0